import React, { useEffect, useState, useContext } from 'react'
import './OrderFormComponent.css'
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import { AppContext } from '../../AppContext'
import { useNavigate } from 'react-router-dom'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import OrderIcon from '../../icons/OrderIcon'

const theme = createTheme({
  overrides: {
    MuiTextField: {
      root: {
        backgroundColor: 'white' // Tło białe
      }
    },
    MuiButton: {
      root: {
        backgroundColor: '#3FC500', // Nowy kolor przycisku
        color: 'white', // Kolor tekstu na przycisku
        '&:hover': {
          backgroundColor: '#3FC500' // Zmiana koloru przycisku po najechaniu
        }
      }
    }
  }
})

const OrderFormComponent = () => {
  var { qrGlobalData, setQrGlobalData, tokenVariable, setTokenVariable } = useContext(AppContext)
  const [inputValue, setInputValue] = useState('')

  const navigate = useNavigate()

  const handleInputChange = event => {
    setInputValue(event.target.value)
  }

  const fetchOrderData = async id => {
    var requestData = { id: id }
    try {
      const response = await fetch(process.env.REACT_APP_API_URL + '/getOrderByIDPart', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestData)
      })
      const data = await response.json()
      if (data.bill) {
        if (data.bill.id) {
          qrGlobalData = data.bill.id
          navigate(`/${data.bill.id}`)
        }
      }
    } catch (error) {
      console.error('Wystąpił błąd podczas pobierania danych:', error)
    }
  }

  const handleSubmit = event => {
    event.preventDefault()
    fetchOrderData(inputValue)
  }

  useEffect(() => {
    document.body.classList.add('custom-body-style')

    return () => {
      document.body.classList.remove('custom-body-style')
    }
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth='lg'>
        <Grid container spacing={2} alignItems='center' justifyContent='center' style={{ minHeight: '50px' }}>
          <Grid item xs={12} sm={12}>
            <div className='element-hello' style={{ textAlign: 'center', paddingTop: '30px' }}>
              <OrderIcon />
            </div>
          </Grid>
          <Grid item xs={12} sm={12}>
            <div className='element-nr' style={{ textAlign: 'center' }}>
              Numer zamówienia
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={2} alignItems='center' justifyContent='center' style={{ minHeight: '80px' }}>
          <Grid item xs={12} sm={12}>
            <div className='element-info' style={{ textAlign: 'center', paddingTop: '11px' }}>
              Wpisz numer zamówienia w poniszym polu
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={2} alignItems='center'>
          <Grid item xs={2} sm={2}></Grid>
          <Grid item xs={8} sm={8}>
            <form onSubmit={handleSubmit}>
              <TextField
                sx={{
                  '& label.Mui-focused': {
                    color: '#FF7A00'
                  },
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                      borderColor: '#FF7A00'
                    }
                  }
                }}
                style={{ backgroundColor: 'white' }}
                variant='outlined'
                value={inputValue}
                onChange={handleInputChange}
                fullWidth
                margin='normal'
              />

              <Grid container justifyContent='center'>
                <Button
                  type='submit'
                  variant='contained'
                  style={{
                    marginTop: '8px',
                    backgroundColor: '#3FC500',
                    borderRadius: '15px',
                    color: '#fff',
                    fontFamily: 'Poppins',
                    fontSize: '20px',
                    fontWeight: '600',
                    boxShadow: 'none'
                  }}
                >
                  Potwierdź
                </Button>
              </Grid>
            </form>

            <Grid item xs={2} sm={2}></Grid>
          </Grid>
        </Grid>
      </Container>
    </ThemeProvider>
  )
}

export default OrderFormComponent
